import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const utilisateurCourant = this.authService.obtenirUtilisateurCourant();
    
    if (!utilisateurCourant) {
      this.router.navigate(['/connexion']);
      return false;
    }

    const rolesAutorises = route.data['roles'] as Array<string>;
    
    if (!rolesAutorises || rolesAutorises.length === 0) {
      return true;
    }

    const roleUtilisateur = utilisateurCourant.role;
    
    if (rolesAutorises.includes(roleUtilisateur)) {
      return true;
    }

    this.router.navigate(['/dashboard']);
    return false;
  }
}
